import { LabelHTMLAttributes } from "react";
import { cn } from "utils/styles";

export const Label = ({ children, className, ...props }: LabelHTMLAttributes<HTMLLabelElement>) => 
<label className={cn("text-base text-secondary", className)} {...props}>{children}</label>
